import React from 'react'
import PropTypes from 'prop-types'

const Button = ({ action, classes, children }) => (
  <button className={classes} type="button" onClick={action}>
    {children}
  </button>
)

Button.propTypes = {
  action: PropTypes.func,
  children: PropTypes.node.isRequired,
  classes: PropTypes.string,
}

Button.defaultProps = {
  action: null,
  classes: 'btn btn-sm btn-outline-secondary',
}

export default Button
